export default {
  install: "Install...",
  size: "Size",
  client: "Client",
  branch: "Branch",
  commit: "Commit",
  tags: "Tags",
  envTags: "Tags",
  ui: "UI",
  version: "Version",
  builtAt: "Built At",
  lastModifiedAt: "Last Modified",
};
